import React, { useEffect, useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { useAppUi } from "@/i18n/appUi";
import { qrLogin } from "@/lib/api";

export default function QrLogin() {
  const { lang, applyAuth } = useApp();
  const t = useAppUi(lang);
  const navigate = useNavigate();
  const [failed, setFailed] = useState(false);
  const ran = useRef(false);

  useEffect(() => {
    if (ran.current) return;
    ran.current = true;
    const raw = window.location.hash.replace(/^#/, "");
    window.history.replaceState({}, document.title, "/qr");
    if (!raw) { setFailed(true); return; }
    qrLogin(raw)
      .then((d) => {
        applyAuth(d.access_token, d.user);
        const staff = ["admin", "trainer", "hr"].includes(d.user?.role);
        navigate(staff ? "/admin/users" : "/app/part2", { replace: true });
      })
      .catch(() => setFailed(true));
  }, [applyAuth, navigate]);

  return (
    <div className="rbl-auth-wrap" data-testid="qr-login-page">
      <div className="rbl-auth-card">
        <img src="/logo_rbl.png" alt="RBL Training" style={{ height: 48 }} />
        {!failed && <><div className="rbl-spinner" /><p className="sub" data-testid="qr-login-busy">{t("qrSigningIn")}</p></>}
        {failed && (
          <>
            <p className="sub" data-testid="qr-login-error">{t("qrInvalid")}</p>
            <Link to="/login" className="rbl-btn block" data-testid="qr-login-to-login">{t("qrToLogin")}</Link>
          </>
        )}
      </div>
    </div>
  );
}
